<template>
    <div class="qoute-step">
        <div class="modaltitleheader">
            <h4 v-show="step && step==1">Choose Category</h4>
            <h4 v-show="step && step==2">Describe the Task</h4>
            <h4 v-show="step && step==3">Choose where and when</h4>
            <h4 v-show="step && step==4">Task Budget</h4>
            <h4 v-show="step && step==5">Task Attachment</h4>
            <h4 v-show="step && step==6 && steps==6">Task Summary</h4>
            <h4 v-show="step && step==6 && steps==7">Login or Sign up</h4>
            <h4 v-show="step && step==7 && steps==7">Task Summary</h4>
            <i class="fa fa-times times" @click="close"></i>
        </div>
        <form style="min-width:50%;height:320px;margin:50px;overflow-y:auto;margin-bottom: 0px;">
            <!-- One "tab" for each step in the form: -->

            <div v-show="step && step == 1" class="tab" style="margin-bottom: 20px;">
                <h5>Who do you need?</h5>
                <category ref="categories" place_holder="Choose a category" v-model="categoryId"></category>
            </div>

            <div v-show="step && step == 2" class="tab">
                <h5>Quickly describe the job you need done</h5>
                <p>
          <textarea
                  v-model="description"
                  class="form-control"
                  placeholder="Enter job description"
                  style="margin-top: 20px;"
          ></textarea>
                </p>
            </div>

            <div v-show="step && step == 3" class="tab">
                <h5>Where do you need the job done?</h5>
                <p>
                    <suburb
                            @getLocation="getLocation"
                            place_holder="Enter a postcode suburb"
                            v-model="suburbId"
                    ></suburb>
                </p>
                <h5>When do you need the job done?</h5>
                <p>
                    <task-execution-date
                            @getExecutionDate="getExecutionDate"
                            place_holder="Select the job execution time"
                            v-model="taskExecutionDateId"
                    ></task-execution-date>
                </p>
            </div>

            <div v-show="step && step == 4" class="tab">
                <h5>What is your budget?</h5>
                <!-- <form class="form-inline"> -->
                <budget
                        container_class
                        div_class="col-md-12 budget-fsar"
                        label_class
                        input_class
                        container_style
                        div_style
                        label_style="width: 100%;margin-bottom:0;padding-bottom: 8px;"
                        input_style="width: 20px;float: left;margin-right: 5px; "
                        hr_style
                        hr_class
                        @getBudget="getBudget"
                        v-model="budgetId"
                ></budget>
            </div>

            <div v-show="step && step == 5" class="tab">
                <h5 class="mb-3">Attach your files (If you don't have any file to attach click on Next button)</h5>
                <file-pond
                        name="test"
                        ref="pond"
                        v-model="attachment"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="true"
                        :files="attachment"
                        maxFileSize="20MB"
                />
            </div>

            <div v-show="step && api_token == null && steps == 7 && step == 6" class="tab">
                <h5 v-if="step_6_type == 'register'">Create account</h5>
                <h5 v-if="step_6_type == 'login'">Login</h5>
                <div class="ps-form__content">
                    <div v-if="step_6_type == 'register'" class="form-group">
                        <input
                                class="form-control"
                                v-model="first_name"
                                type="text"
                                placeholder="Enter your first name"
                        />
                    </div>
                    <div v-if="step_6_type == 'register'" class="form-group">
                        <input
                                class="form-control"
                                v-model="last_name"
                                type="text"
                                placeholder="Enter your last name"
                        />
                    </div>
                    <div class="form-group">
                        <input
                                class="form-control"
                                v-model="email"
                                type="email"
                                placeholder="Enter your email address"
                        />
                    </div>
                    <div v-if="step_6_type == 'register'" class="form-group">
                        <tel-input v-model="mobile_number"></tel-input>
                    </div>
                    <div class="form-group">
                        <input
                                type="password"
                                class="form-control"
                                v-model="password"
                                placeholder="Enter your password"
                        />
                    </div>
                    <div v-if="step_6_type == 'login'" class="form-group">
                        <a href="#" @click.prevent="changeStep5TypeToRegister()">Create an account / Sign up</a>
                    </div>
                </div>
            </div>
            <div v-show="step && api_token != null && steps == 7 && step == 6" class="tab">
                <h5 v-if="step_6_type == 'register'">Registered successfully</h5>
                <h5 v-if="step_6_type == 'login'">Loged in successfully</h5>
                <div class="ps-form__content"></div>
            </div>
            <div v-show="step && api_token != null && step == steps" class="tab">
                <h5>Task detail</h5>
                <hr/>
                <div class="row mb-3">
                    <div class="col-6">Category</div>
                    <a href="#" @click.prevent="step = 1" class="col-6" v-if="category">{{ category.title }}</a>
                </div>
                <div class="row mb-3">
                    <div class="col-6">Description</div>
                    <a href="#" @click.prevent="step = 2" class="col-6" v-if="description">{{ description }}</a>
                </div>
                <div class="row mb-3">
                    <div class="col-6">Subrub</div>
                    <a href="#" @click.prevent="step = 3" class="col-6" v-if="location">{{ location }}</a>
                </div>
                <div class="row mb-3">
                    <div class="col-6">Execution date</div>
                    <a
                            href="#"
                            @click.prevent="step = 3"
                            class="col-6"
                            v-if="executionDate"
                    >{{ executionDate }}</a>
                </div>
                <div class="row mb-3">
                    <div class="col-6">Budget</div>
                    <a href="#" @click.prevent="step = 4" class="col-6" v-if="budget">{{ budget }}</a>
                </div>
                <div class="row">
                    <div class="col-6">Attachments</div>
                    <a href="#" @click.prevent="step = 5" class="col-6"
                       v-if="attachment && step>5 && attachment.length>0">
                        <ul v-for="attach in attachment">
                            <li>{{attach.filename}}</li>
                        </ul>
                    </a>
                </div>
            </div>
        </form>
        <div style="margin: 5px 40px;">
            <div style="margin: 0px auto;bottom: 5px;right: 70px;position: absolute;">
                <button
                        v-if="step > 1"
                        type="button"
                        id="prevBtn"
                        class="ps-btn ps-btn--sm"
                        @click="prev"
                >Previous
                </button>
                <button
                        v-if="steps == 6 && step < steps"
                        type="button"
                        class="ps-btn ps-btn--sm"
                        @click="next"
                >Next
                </button>
                <button
                        v-if="steps == 7 && step < steps && step != 6"
                        type="button"
                        class="ps-btn ps-btn--sm"
                        @click="next"
                >Next
                </button>
                <button
                        v-if="steps == 7 && step < steps && step == 6 && registered"
                        type="button"
                        class="ps-btn ps-btn--sm"
                        @click="next"
                >Next
                </button>
                <button
                        v-if="step == steps && showPostBtn"
                        type="button"
                        class="ps-btn ps-btn--sm ps-btn--gradient btn-fsdfh"
                        @click="post"
                >Post
                </button>
                <button
                        v-if="step == 6 && steps == 7 && !registered"
                        type="button"
                        class="ps-btn ps-btn--sm ps-btn--gradient btn-fsdfh"
                        @click="signup"
                >{{ step_6_btn_caption }}
                </button>
            </div>
        </div>

        <!-- Circles which indicates the steps of the form: -->
        <div style="margin-left: 10px; margin-top: 23px;">
            <span class="step" :class="{ 'active finish': step == 1 }"></span>
            <span class="step" :class="{ 'active finish': step == 2 }"></span>
            <span class="step" :class="{ 'active finish': step == 3 }"></span>
            <span class="step" :class="{ 'active finish': step == 4 }"></span>
            <span class="step" :class="{ 'active finish': step == 5 }"></span>
            <span class="step" :class="{ 'active finish': step == 6 }"></span>
            <span v-if="steps == 7" class="step" :class="{ 'active finish': step == 7 }"></span>
        </div>
    </div>
</template>

<script>

    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginFileEncode from "filepond-plugin-file-encode";
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

    const FilePond = vueFilePond(
        FilePondPluginFileValidateType,
        FilePondPluginFileEncode,
        FilePondPluginFileValidateSize
    );

    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    import Suburb from "./../../Suburb";
    import Money from "./../../Money";
    import TaskExecutionDate from "./../../TaskExecutionDate";
    import Budget from "./../../Budget";
    import TelInput from "./../../TelInput";
    import Category from "../../Category";

    export default {
        components: {
            Loading,
            Suburb,
            Money,
            TaskExecutionDate,
            Budget,
            TelInput,
            Category
        },
        props: {
            first_step: {
                type: [String, Number],
                default: 1
            },
            category_id: {
                type: [String, Number],
                default: null
            },
            suburb_id: {
                type: [String, Number],
                default: null
            },
            task_execution_date_id: {
                type: [String, Number],
                default: null
            },
            budget_id: {
                type: [String, Number],
                default: null
            },
            steps: {
                type: [String, Number],
                default: 6
            },
            redirect_url: {
                type: String,
                default: "/dashboard/task"
            }
        },
        data() {
            return {
                showPostBtn: true,
                word: {},
                text: {},
                loading: false,
                step: this.first_step,
                categoryId: this.category_id,
                budgetId: this.budget_id,
                description: null,
                suburbId: this.suburb_id,
                taskExecutionDateId: this.task_execution_date_id,
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                mobile_number: null,
                registered: false,
                api_token: null,
                step_6_type: "login",
                step_6_btn_caption: "Login",
                category: null,
                location: null,
                executionDate: null,
                budget: null,
                attachment: this.attachment,
            };
        },
        created() {
            this.word = window.word;
            this.text = window.text;
            if (window.api_token != undefined && window.api_token != null) {
                this.api_token = window.api_token;
            }
        },
        methods: {
            close() {
                this.$emit("close", true);
            },
            changeStep5TypeToRegister() {
                this.step_6_type = "register";
            },
            getExecutionDate(date) {
                this.executionDate = date;
            },
            getBudget(budget) {
                this.budget = budget.title;
            },
            getLocation(location) {
                this.location = location;
            },
            prev: function () {
                if (this.step > 1) {
                    this.step--;
                }
            },
            next: function () {
                if (this.step < this.steps) {
                    switch (this.step) {
                        case 1:
                            if (this.categoryId != null) {
                                this.step++;
                            } else {
                                this.$toast.error("Choose a category", {
                                    queue: true
                                });
                            }
                            break;
                        case 2:
                            if (this.description != null && this.description.length >= 15) {
                                this.step++;
                            } else {
                                if (!this.description || this.description.length == 0) {
                                    this.$toast.error("Enter job description", {
                                        queue: true
                                    });

                                    return;
                                }
                                if (this.description.length < 15) {
                                    this.$toast.error("Description must be at least 15 character", {
                                        queue: true
                                    });
                                }
                            }
                            break;
                        case 3:
                            if (this.suburbId != null && this.taskExecutionDateId != null) {
                                this.step++;
                            } else {
                                this.$toast.error("Set suburb & execution time", {
                                    queue: true
                                });
                            }
                            break;
                        case 4:
                            if (this.budgetId != null) {
                                this.step++;
                            } else {
                                this.$toast.error("Select budget", {
                                    queue: true
                                });
                            }
                            break;
                        case 5:
                            let hasAttachmentError = 0;
                            if (this.attachment.length > 0) {
                                this.attachment.forEach(function (attach) {
                                    if (attach.status === 8) {
                                        hasAttachmentError++;
                                    }
                                });

                                if (hasAttachmentError !== 0) {
                                    this.$toast.error("Invalid Files", {
                                        queue: true
                                    });
                                } else {
                                    this.step++;
                                }
                            } else {
                                this.step++;
                            }
                            break;
                        case 6:
                            this.step++;

                            break;
                    }
                }
            },
            show() {
                this.$modal.show("create-task-modal");
            },
            hide() {
                this.$modal.hide("create-task-modal");
            },
            post() {
                this.$Progress.start();
                this.showPostBtn = false;
                let self = this;

                let attachment = [];
                if (this.attachment.length > 0) {
                    this.attachment.forEach(function (attach) {
                        let attachmentItem = {};
                        attachmentItem.name = attach.file.name;
                        attachmentItem.size = attach.file.size;
                        attachmentItem.type = attach.file.type;
                        attachmentItem.data = attach.getFileEncodeDataURL();
                        attachment.push(attachmentItem);
                    });
                }

                let data = {
                    description: self.description,
                    category_id: self.categoryId,
                    task_execution_date_id: self.taskExecutionDateId,
                    budget_id: self.budgetId,
                    suburb_id: self.suburbId,
                    first_name: self.first_name,
                    last_name: self.last_name,
                    mobile_number: self.mobile_number,
                    password: self.password,
                    email: self.email,
                    attachment: attachment
                };

                axios({
                    method: "post",
                    url: "/api/v1/task?api_token=" + self.api_token,
                    data
                })
                    .then(function (res) {
                        self.$Progress.finish();
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            self.$emit("getTask", res.data.data);
                            if (
                                self.redirect_url != null &&
                                self.redirect_url != undefined &&
                                self.redirect_url.trim() != ""
                            ) {
                                setTimeout(() => {
                                    location.replace(self.redirect_url);
                                }, 1000);
                            }
                        } else {
                            self.$Progress.fail();
                        }
                    })
                    .catch(function (e) {
                        self.$Progress.fail();
                        if (e.response.status == 422) {
                            self.errors = e.response.data.errors;
                            console.log(self.errors);
                            for (let error in self.errors) {
                                self.$toast.error(self.errors[error][0]);
                            }
                        }else if (e.response.status == 400){
                            if (e.response.data.msg){
                                self.$toast.error(e.response.data.msg);
                            }
                        } else {
                            console.log(e);
                        }
                    });
            },
            signup() {
                this.$Progress.start();
                //this.showPostBtn = false;
                let self = this;
                let data = {
                    first_name: self.first_name,
                    last_name: self.last_name,
                    mobile_number: self.mobile_number,
                    password: self.password,
                    email: self.email
                };

                axios({
                    method: "post",
                    url: "/" + self.step_6_type,
                    data
                })
                    .then(function (res) {
                        self.$Progress.finish();
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            self.api_token = res.data.data.api_token;
                            window.api_token = res.data.data.api_token;
                            self.registered = true;
                            //self.showPostBtn = true;
                            //self.step = 4;
                        } else {
                            self.$Progress.fail();
                        }
                    })
                    .catch(function (e) {
                        self.$Progress.fail();
                        if (e.response.status == 422) {
                            self.errors = e.response.data.errors;
                            console.log(self.errors);
                            for (let error in self.errors) {
                                self.$toast.error(self.errors[error][0]);
                            }
                        } else {
                            console.log(e);
                        }
                    });
            }
        },
        watch: {
            categoryId: function (categoryId) {
                this.category = this.$refs.categories.categories
                    .find(category => category.id === categoryId);
            },
            step: {
                immediate: true,
                handler() {
                    this.$emit("getStep", this.step);
                }
            },
            step_6_type: {
                immediate: true,
                handler() {
                    if (this.step_6_type == "login") {
                        this.step_6_btn_caption = "Login";
                    } else {
                        this.step_6_btn_caption = "Register";
                    }
                }
            }
        }
    };
</script>
<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>
